import { IInventoryCountDetail } from './IInventoryCountDetail';

export class IInventoryCount {
  inventoryCount: IInventoryCountDetail;
  inventoryCountId: string;
  inventoryTemplateId: string;
  equipmentKeyId: number;
  startDate: Date;
  endDate: Date;
  jobId: string;
  jobName: string;
  jobDescription: string;
  projectManagerHRRef?: number;
  projectManagerName: string;
  modifiedBy: string;
  modifiedDate: Date;
  isActive: boolean;
  inventoryStatusId: string;
  inventoryStatusName: string;
  inventoryStatusDescription: string;
  inventoryCountDetails: IInventoryCountDetail[];
  isAssignTemplate: boolean;
  warehouseId: number;
  warehouseName: string;
}
